import { Spinner } from './Spinner';
import { cn } from '@/lib/utils';

interface PageLoaderProps {
    /** Message to display while loading */
    message?: string;
    /** Minimum height for the loader area */
    minHeight?: 'sm' | 'md' | 'lg' | 'full';
    /** Additional CSS classes */
    className?: string;
}

const heightClasses: Record<string, string> = {
    sm: 'min-h-[200px]',
    md: 'min-h-[400px]',
    lg: 'min-h-[600px]',
    full: 'min-h-[calc(100vh-4rem)]',
};

/**
 * Page Loader Component
 *
 * Full-page loading state with centered spinner and message.
 * Use this for initial page loads or route transitions.
 *
 * @example
 * if (isLoading) {
 *   return <PageLoader message="Loading your profile..." />;
 * }
 */
export const PageLoader = ({
    message = 'Loading...',
    minHeight = 'full',
    className
}: PageLoaderProps) => {
    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center',
                heightClasses[minHeight],
                className
            )}
            role="status"
            aria-label={message}
        >
            <Spinner size="xl" label={message} />
            <p className="mt-4 text-sm font-medium text-muted-foreground">{message}</p>
        </div>
    );
};

export default PageLoader;
